import Vue from 'vue';
import Vuex from 'vuex';
import Auth from './modules/auth.module';
import User from './modules/user.module';
import Notifications from './modules/notifications.module';
import Pedido from './modules/pedido.module';
import Cliente from './modules/cliente.module';
import Empresas from "./modules/empresas.module";
import Appbar from "./modules/appbar.module";
import AppConfig from './modules/config.module';

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
  },
  mutations: {
  },
  actions: {
  },
  modules: {
    Auth,
    User,
    Notifications,
    Pedido,
    Cliente,
    Empresas,
    Appbar,
    AppConfig
  }
})
